// extracted by mini-css-extract-plugin
export default {"modal":"CompletPay_modal__wjQky","title":"CompletPay_title__7DU1-","complete":"CompletPay_complete__7c2PA","float":"CompletPay_float__5BwJt"};